import { render } from "./PeopleBerkson.vue?vue&type=template&id=e69ff1fa"
import script from "./PeopleBerkson.vue?vue&type=script&lang=js"
export * from "./PeopleBerkson.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__